module.exports = __webpack_public_path__ + "img/users-orange.0c9fcd9.png";